/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  EcommerceUserApiCreateReq,
  EcommerceUserApiSwitchReq,
  EcommerceUserApiTestReq,
  EcommerceUserApiUpdateReq,
  ResponseBoolean,
  ResponseConnectionTestResult,
  ResponseEcommerceOrderSyncResponseVo,
  ResponseEcommerceProductImportPageVo,
  ResponseEcommerceUserApiResponseVo,
  ResponseListEcommerceUserApiResponseVo,
} from '../models/index';
import {
    EcommerceUserApiCreateReqFromJSON,
    EcommerceUserApiCreateReqToJSON,
    EcommerceUserApiSwitchReqFromJSON,
    EcommerceUserApiSwitchReqToJSON,
    EcommerceUserApiTestReqFromJSON,
    EcommerceUserApiTestReqToJSON,
    EcommerceUserApiUpdateReqFromJSON,
    EcommerceUserApiUpdateReqToJSON,
    ResponseBooleanFromJSON,
    ResponseBooleanToJSON,
    ResponseConnectionTestResultFromJSON,
    ResponseConnectionTestResultToJSON,
    ResponseEcommerceOrderSyncResponseVoFromJSON,
    ResponseEcommerceOrderSyncResponseVoToJSON,
    ResponseEcommerceProductImportPageVoFromJSON,
    ResponseEcommerceProductImportPageVoToJSON,
    ResponseEcommerceUserApiResponseVoFromJSON,
    ResponseEcommerceUserApiResponseVoToJSON,
    ResponseListEcommerceUserApiResponseVoFromJSON,
    ResponseListEcommerceUserApiResponseVoToJSON,
} from '../models/index';

export interface EcommerceUserApisGetRequest {
    businessPlatformId?: number;
    enable?: number;
    connectionStatus?: string;
    keyword?: string;
}

export interface EcommerceUserApisIdDeleteRequest {
    id: number;
}

export interface EcommerceUserApisIdEnablePatchRequest {
    id: number;
    ecommerceUserApiSwitchReq?: EcommerceUserApiSwitchReq;
}

export interface EcommerceUserApisIdGetRequest {
    id: number;
}

export interface EcommerceUserApisIdProductsGetRequest {
    id: number;
    nextToken?: string;
    maxPerPage?: number;
}

export interface EcommerceUserApisIdPutRequest {
    id: number;
    ecommerceUserApiUpdateReq?: EcommerceUserApiUpdateReq;
}

export interface EcommerceUserApisIdSyncPostRequest {
    id: number;
    lookbackHours?: number;
}

export interface EcommerceUserApisIdTestPostRequest {
    id: number;
}

export interface EcommerceUserApisPostRequest {
    ecommerceUserApiCreateReq?: EcommerceUserApiCreateReq;
}

export interface EcommerceUserApisTestPostRequest {
    ecommerceUserApiTestReq?: EcommerceUserApiTestReq;
}

/**
 * 
 */
export class APIEcommerceUserApiControllerApi extends runtime.BaseAPI {

    /**
     * 查询当前用户API列表
     * 查询当前用户API列表
     */
    async ecommerceUserApisGetRaw(requestParameters: EcommerceUserApisGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListEcommerceUserApiResponseVo>> {
        const queryParameters: any = {};

        if (requestParameters['businessPlatformId'] != null) {
            queryParameters['businessPlatformId'] = requestParameters['businessPlatformId'];
        }

        if (requestParameters['enable'] != null) {
            queryParameters['enable'] = requestParameters['enable'];
        }

        if (requestParameters['connectionStatus'] != null) {
            queryParameters['connectionStatus'] = requestParameters['connectionStatus'];
        }

        if (requestParameters['keyword'] != null) {
            queryParameters['keyword'] = requestParameters['keyword'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ecommerce/user-apis`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListEcommerceUserApiResponseVoFromJSON(jsonValue));
    }

    /**
     * 查询当前用户API列表
     * 查询当前用户API列表
     */
    async ecommerceUserApisGet(requestParameters: EcommerceUserApisGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListEcommerceUserApiResponseVo> {
        const response = await this.ecommerceUserApisGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 删除平台API
     * 删除平台API
     */
    async ecommerceUserApisIdDeleteRaw(requestParameters: EcommerceUserApisIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBoolean>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling ecommerceUserApisIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ecommerce/user-apis/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBooleanFromJSON(jsonValue));
    }

    /**
     * 删除平台API
     * 删除平台API
     */
    async ecommerceUserApisIdDelete(requestParameters: EcommerceUserApisIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBoolean> {
        const response = await this.ecommerceUserApisIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 用户平台API·启用或停用
     * 用户平台API·启用或停用
     */
    async ecommerceUserApisIdEnablePatchRaw(requestParameters: EcommerceUserApisIdEnablePatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBoolean>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling ecommerceUserApisIdEnablePatch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ecommerce/user-apis/{id}/enable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: EcommerceUserApiSwitchReqToJSON(requestParameters['ecommerceUserApiSwitchReq']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBooleanFromJSON(jsonValue));
    }

    /**
     * 用户平台API·启用或停用
     * 用户平台API·启用或停用
     */
    async ecommerceUserApisIdEnablePatch(requestParameters: EcommerceUserApisIdEnablePatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBoolean> {
        const response = await this.ecommerceUserApisIdEnablePatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 查询平台API详情
     * 查询平台API详情
     */
    async ecommerceUserApisIdGetRaw(requestParameters: EcommerceUserApisIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseEcommerceUserApiResponseVo>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling ecommerceUserApisIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ecommerce/user-apis/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseEcommerceUserApiResponseVoFromJSON(jsonValue));
    }

    /**
     * 查询平台API详情
     * 查询平台API详情
     */
    async ecommerceUserApisIdGet(requestParameters: EcommerceUserApisIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseEcommerceUserApiResponseVo> {
        const response = await this.ecommerceUserApisIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 拉取平台商品（返回注册商品结构信息）
     * 拉取平台商品（返回注册商品结构信息）
     */
    async ecommerceUserApisIdProductsGetRaw(requestParameters: EcommerceUserApisIdProductsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseEcommerceProductImportPageVo>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling ecommerceUserApisIdProductsGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['nextToken'] != null) {
            queryParameters['nextToken'] = requestParameters['nextToken'];
        }

        if (requestParameters['maxPerPage'] != null) {
            queryParameters['maxPerPage'] = requestParameters['maxPerPage'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ecommerce/user-apis/{id}/products`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseEcommerceProductImportPageVoFromJSON(jsonValue));
    }

    /**
     * 拉取平台商品（返回注册商品结构信息）
     * 拉取平台商品（返回注册商品结构信息）
     */
    async ecommerceUserApisIdProductsGet(requestParameters: EcommerceUserApisIdProductsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseEcommerceProductImportPageVo> {
        const response = await this.ecommerceUserApisIdProductsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 修改平台API
     * 修改平台API
     */
    async ecommerceUserApisIdPutRaw(requestParameters: EcommerceUserApisIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseEcommerceUserApiResponseVo>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling ecommerceUserApisIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ecommerce/user-apis/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: EcommerceUserApiUpdateReqToJSON(requestParameters['ecommerceUserApiUpdateReq']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseEcommerceUserApiResponseVoFromJSON(jsonValue));
    }

    /**
     * 修改平台API
     * 修改平台API
     */
    async ecommerceUserApisIdPut(requestParameters: EcommerceUserApisIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseEcommerceUserApiResponseVo> {
        const response = await this.ecommerceUserApisIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 立即同步订单【测试接口】
     * 立即同步订单【测试接口】
     */
    async ecommerceUserApisIdSyncPostRaw(requestParameters: EcommerceUserApisIdSyncPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseEcommerceOrderSyncResponseVo>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling ecommerceUserApisIdSyncPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['lookbackHours'] != null) {
            queryParameters['lookbackHours'] = requestParameters['lookbackHours'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ecommerce/user-apis/{id}/sync`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseEcommerceOrderSyncResponseVoFromJSON(jsonValue));
    }

    /**
     * 立即同步订单【测试接口】
     * 立即同步订单【测试接口】
     */
    async ecommerceUserApisIdSyncPost(requestParameters: EcommerceUserApisIdSyncPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseEcommerceOrderSyncResponseVo> {
        const response = await this.ecommerceUserApisIdSyncPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 测试已保存API
     * 测试已保存API
     */
    async ecommerceUserApisIdTestPostRaw(requestParameters: EcommerceUserApisIdTestPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseConnectionTestResult>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling ecommerceUserApisIdTestPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ecommerce/user-apis/{id}/test`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseConnectionTestResultFromJSON(jsonValue));
    }

    /**
     * 测试已保存API
     * 测试已保存API
     */
    async ecommerceUserApisIdTestPost(requestParameters: EcommerceUserApisIdTestPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseConnectionTestResult> {
        const response = await this.ecommerceUserApisIdTestPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 新增平台API
     * 新增平台API
     */
    async ecommerceUserApisPostRaw(requestParameters: EcommerceUserApisPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseEcommerceUserApiResponseVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ecommerce/user-apis`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EcommerceUserApiCreateReqToJSON(requestParameters['ecommerceUserApiCreateReq']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseEcommerceUserApiResponseVoFromJSON(jsonValue));
    }

    /**
     * 新增平台API
     * 新增平台API
     */
    async ecommerceUserApisPost(requestParameters: EcommerceUserApisPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseEcommerceUserApiResponseVo> {
        const response = await this.ecommerceUserApisPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 测试未保存API
     * 测试未保存API
     */
    async ecommerceUserApisTestPostRaw(requestParameters: EcommerceUserApisTestPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseConnectionTestResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ecommerce/user-apis/test`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EcommerceUserApiTestReqToJSON(requestParameters['ecommerceUserApiTestReq']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseConnectionTestResultFromJSON(jsonValue));
    }

    /**
     * 测试未保存API
     * 测试未保存API
     */
    async ecommerceUserApisTestPost(requestParameters: EcommerceUserApisTestPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseConnectionTestResult> {
        const response = await this.ecommerceUserApisTestPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
